import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { CustomerCrmService, RmsMessageService, RmsPulldownService } from '@services';
import { SampleRequestFormComponent } from './sample-request-form/sample-request-form.component';

@Component({
  selector: 'app-customer-samples',
  imports: [RmsModule],
  templateUrl: './customer-samples.component.html',
  styleUrl: './customer-samples.component.scss'
})
export class CustomerSamplesComponent implements OnChanges {
  @Input() companyId!: number;
  @Input() canEdit = false;
  Samples: any[] = [];

  Columns: Column[] = [
    { label: 'Sample', key: 'SampleCode', width: 12 },
    { label: 'Requested', key: 'RequestedDisplay', width: 14 },
    { label: 'Coffee', key: 'InventoryTypeName', width: 24 },
    { label: 'Status', key: 'StatusName', width: 14, cellClass: (row) => 'cell-badge status-' + String(row.StatusName || '').toLowerCase() },
    { label: 'Follow Up', key: 'FollowUpDisplay', width: 20 },
  ];

  constructor(
    private crm: CustomerCrmService,
    private message: RmsMessageService,
    private pulldown: RmsPulldownService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companyId']) {
      this.load();
    }
  }

  load() {
    if (!this.companyId) return;
    this.crm.getSampleHistory(this.companyId).subscribe({
      next: (samples) => {
        this.Samples = (samples || []).map((s: any) => ({
          ...s,
          SampleCode: 'S-' + s.CustomerSampleRequestID,
          RequestedDisplay: s.RequestedDate ? new Date(s.RequestedDate).toLocaleDateString() : '—',
          FollowUpDisplay: s.CompletedDate ? 'Completed' : (s.FollowUpDate ? new Date(s.FollowUpDate).toLocaleDateString() : '—')
        }));
      },
      error: (err) => this.message.error('Failed to load sample history: ' + this.errorText(err))
    });
  }

  openSampleForm() {
    if (!this.canEdit) return;
    const ref = this.pulldown.open(SampleRequestFormComponent, {
      title: 'Request Sample',
      width: 'clamp(480px, 50vw, 720px)',
      data: {}
    });

    ref.afterClosed().subscribe((result: any) => {
      if (!result || result.cancelled) return;
      result.CompanyID = this.companyId;
      result.RequestedBy = localStorage.getItem('GUID');
      this.crm.saveSampleRequest(result).subscribe({
        next: () => {
          this.message.success('Sample requested successfully');
          this.load();
        },
        error: (err) => this.message.error('Failed to request sample: ' + this.errorText(err))
      });
    });
  }

  private errorText(err: any): string {
    return err?.error?.error?.message || err?.message || 'Unknown error';
  }
}
